export const NotificationTypesEnum = {
    CAMPAIGN_BIRTHDAY: "campaign_birthday",
    CAMPAIGN_VISANA_GAMEDAY :"campaign_visana_gameday",
    CAMPAIGN_NO_SHOW : "campaign_no_show",
    CAMPAIGN_GAMEDAY :"campaign_gameday",
};
